<style lang="scss">
@media screen and (min-width: 55rem) {
  .cloud-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .cloud {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      height: auto;
      .cloud-img {
        width: 60%;
        .cloud-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
          background-image: url("https://intime-web2021.oss-cn-shanghai.aliyuncs.com/1641455293134-homepage-3.png");
          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .cloud-text {
        width: 40%;
        min-height: 10rem;
        margin-top: 3rem;
        .cloud-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .cloud-introduction {
          span {
            font-size: 1.5rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 500;
            color: #000;
            border-bottom: solid #000 1px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .cloud-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .cloud {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
      height: auto;
      .cloud-img {
        width: 100%;
        .cloud-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
          background-image: url("https://intime-web2021.oss-cn-shanghai.aliyuncs.com/1641455293134-homepage-3.png");

          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .cloud-text {
        width: 100%;
        min-height: 10rem;
        margin-top: 3rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .cloud-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .cloud-introduction {
          span {
            font-size: 1.5rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 500;
            color: #000;
            border-bottom: solid #000 1px;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="cloud-container">
    <div class="cloud">
      <div class="cloud-img"><div class="cloud-img-content"></div></div>
      <div class="cloud-text">
        <div class="cloud-title">银泰云图</div>
        <a href="/cloudPicture">
          <div class="cloud-introduction"><span>CEO演讲</span></div>
        </a>
        <a href="/cloudPicture">
          <div class="cloud-introduction"><span>明星到店</span></div>
        </a>
        <a href="/cloudPicture">
          <div class="cloud-introduction"><span>银泰活动</span></div>
        </a>
        <a href="/cloudPicture">
          <div class="cloud-introduction"><span>银泰人物</span></div>
        </a>
        <a href="/cloudPicture"
          ><ButtonRed style="margin-top: 2rem"></ButtonRed
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonRed from "@/yintai/view/component/ButtonRed";

export default {
  name: "cloud",
  components: { ButtonRed },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>